<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent width="fit-content" content-class="round-2xl")
  v-card.neutral700
    v-card-title.py-2
      v-spacer
      v-btn(icon @click="closeDialog" small color="neutral100")
        v-icon mdi-close
    v-card-text
      v-window(v-model="currentIndex" show-arrows continuous)
        template(#prev="{ on, attrs }")
          v-btn(v-bind="attrs" large icon color="neutral100" v-on="on")
            v-icon(size="44") mdi-chevron-left
        template(#next="{ on, attrs }")
          v-btn(v-bind="attrs" large icon color="neutral100" v-on="on")
            v-icon(size="44") mdi-chevron-right
        v-window-item(v-for="(image, index) in images" :key="index" :value="index")
          v-img(:src="image" eager contain max-width="90vw" max-height="89vh" min-width="30vw" min-height="30vh")
            template(#placeholder)
              .d-flex.justify-center.align-center.fill-height
                v-progress-circular(:width="3" :size="75" color="white" indeterminate)
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    images: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  computed: {
    ...mapGetters({ displaySize: 'ui/getDisplaySize' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    getHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '120vh'
        case 'x-small':
          return '110vh'
        case 'small':
          return '100vh'
        case 'medium':
          return '89vh'
        case 'large':
          return '80vh'
        case 'x-large':
          return '72vh'
        default:
          return '80vh'
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.fit-content {
  width: fit-content !important;
}
</style>

<style lang="scss" scoped>
.fit-content {
  width: fit-content !important;
}
</style>